import {createSlice} from '@reduxjs/toolkit'

const initialState = {
  filters: [{}], // Initialize with empty object for state filter
  filterDetailsLoading: true // Start as true until data is loaded
}

const breadCrumbsSlice = createSlice({
  name: 'breadCrumbs',
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.filters = action.payload
    },
    updateFilterAtIndex: (state, action) => {
      const {index, data} = action.payload
      if (state.filters[index]) {
        state.filters[index] = {...state.filters[index], ...data}
      } else {
        state.filters[index] = data
      }
    },
    updateFilterValues: (state, action) => {
      const {index, values} = action.payload
      if (state.filters[index]) {
        state.filters[index].values = values
      }
    },
    updateFilterDefault: (state, action) => {
      const {index, defaultValue} = action.payload
      if (state.filters[index]) {
        state.filters[index].default = defaultValue
      }
    },
    updateStateAbbreviation: (state, action) => {
      if (state.filters[0]) {
        state.filters[0].stateAbbreviation = action.payload
      }
    },
    updateFiltersImmer: (state, action) => {
      // This reducer accepts a draft updater function
      // The action.payload should be a function that modifies the draft
      action.payload(state.filters)
    },
    setFilterDetailsLoading: (state, action) => {
      state.filterDetailsLoading = action.payload
    }
  }
})

export const {
  setFilters,
  updateFilterAtIndex,
  updateFilterValues,
  updateFilterDefault,
  updateStateAbbreviation,
  updateFiltersImmer,
  setFilterDetailsLoading
} = breadCrumbsSlice.actions

export const selectFilters = (state) => state.breadCrumbs.filters
export const selectFilterDetailsLoading = (state) => state.breadCrumbs.filterDetailsLoading

export default breadCrumbsSlice.reducer
